import { render } from "./GoogleAPIServicesDisclosure.vue?vue&type=template&id=5f65a5ed&scoped=true"
const script = {}

import "./GoogleAPIServicesDisclosure.vue?vue&type=style&index=0&id=5f65a5ed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f65a5ed"]])

export default __exports__